module.exports = __webpack_public_path__ + "img/ico_stock.5042c1dc.png";